import React, { useState } from 'react';
import './loadingButton.css';

export default function LoadingButton({ onClick, children, className = '' }) {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    // await new Promise((resolve) => setTimeout(resolve, 2000));
    await onClick();
    setIsLoading(false);
  };

  return (
    <button
      className={`loading-button ${className}`}
      onClick={handleClick}
      disabled={isLoading}
      type="button"
    >
      {isLoading ? <div className="spinner"></div> : children}
    </button>
  );
}
